var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11V14",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11V14",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5L1.79289 9.70711C1.60536 9.89464 1.351 10 1.08579 10H0",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5L12.2071 9.70711C12.3946 9.89464 12.649 10 12.9142 10H14",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7L1 5",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7L13 5",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5L6.29289 5.79289C6.10536 5.60536 5.851 5.5 5.58579 5.5H5C4.44772 5.5 4 5.94772 4 6.5V10C4 11.6569 5.34315 13 7 13C8.65685 13 10 11.6569 10 10V6.5C10 5.94772 9.55228 5.5 9 5.5H8.41421C8.149 5.5 7.89464 5.60536 7.70711 5.79289L7 6.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30159 0.85601L5.43751 0.0446328C5.47815 0.0156047 5.52685 0 5.57679 0C5.76304 0 5.87967 0.204697 5.80203 0.373997C4.97104 2.18606 6.21947 3.53168 7 4C7.78054 3.53168 9.02896 2.18606 8.19797 0.373997C8.12033 0.204697 8.23696 0 8.42321 0C8.47315 0 8.52185 0.0156047 8.56249 0.0446328L9.69841 0.85601C10.9032 1.71659 11.0469 3.45305 10 4.5L9.86817 4.69775C9.60559 4.57103 9.31109 4.5 9 4.5H8.41421C7.88378 4.5 7.37507 4.71071 7 5.08579C6.62493 4.71071 6.11622 4.5 5.58579 4.5H5C4.68891 4.5 4.39441 4.57103 4.13183 4.69775L4 4.5C2.95305 3.45305 3.09677 1.71659 4.30159 0.85601Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsect);
export default __webpack_public_path__ + "static/media/insect.b87cbff2.svg";
export { ForwardRef as ReactComponent };